// InPlants.tsx - умный родитель
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { useContext } from "react";
import { Context } from "../../../index";
import Lines from "../components/Lines/Lines";
import Station from "../components/Station/Station";
import Modules from "../components/Modules/Modules";
// РГ-07 (ФЗ-152): вкладка «Машиноместа» в карточке объекта.
import MachinePlaces from "../components/MachinePlaces/MachinePlaces";

export default observer(function InPlants() {
  const { store, inplantsStore } = useContext(Context);
  const [tab, setTab] = useState<"objects" | "places">("objects");

  // `E.19`: вкладка «Машиноместа» — только роли с доступом (root); остальным
  // её не показываем, а не прячем содержимое.
  const canSeePlaces = store.user?.role === "root";

  // Инициализация inplantsStore при выборе завода
  useEffect(() => {
    if (store.plant && store.plant.id) {
      inplantsStore.initialize(store.plant);
      inplantsStore.loadPlantData(store.plant.id);
    }
  }, [store.plant?.id]);

  // Авто-рефреш
  useEffect(() => {
    const isDev = inplantsStore.isDev;
    const plantId = inplantsStore.plant?.id;
    const hasActiveModule = inplantsStore.activeModule?.id;

    if (plantId && !hasActiveModule && !isDev && inplantsStore.isPoll) {
      inplantsStore.startAutoRefresh(plantId, 3000);
    }

    return () => {
      inplantsStore.stopAutoRefresh();
    };
  }, [
    inplantsStore.plant?.id,
    inplantsStore.activeModule?.id,
    inplantsStore.isDev,
    inplantsStore.isPoll,
  ]);

  return (
    <div className="inplants">
      <div className="inplants_tabs">
        <button
          type="button"
          className={tab === "objects" ? "inplants_tab active" : "inplants_tab"}
          onClick={() => setTab("objects")}
        >
          Объект
        </button>
        {canSeePlaces ? (
          <button
            type="button"
            className={tab === "places" ? "inplants_tab active" : "inplants_tab"}
            onClick={() => setTab("places")}
          >
            Машиноместа
          </button>
        ) : null}
      </div>

      {canSeePlaces && tab === "places" && store.plant?.id ? (
        <MachinePlaces plantId={store.plant.id} />
      ) : (
        <>
          <Lines />
          <Modules />
          <Station />
        </>
      )}
    </div>
  );
});
